export default "__VITE_ASSET__BB4Gc$Wt__"